import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ValuePropResponse } from '../../domain/preferences';
import { useCompanyQuery } from '../company/useCompanyQuery';

import { preferencesApi } from './api';
import { preferencesQueryKey } from './preferencesQueryKey';

const fetchValuePropPreferences = async (): Promise<ValuePropResponse> => preferencesApi.getValuePropSettings();

export const useValuePropPreferencesQuery = (options?: UseQueryOptions<ValuePropResponse>) => {
  const { domain } = useCompanyQuery().data ?? {};

  return useQuery<ValuePropResponse>({
    queryKey: preferencesQueryKey.valueProp(),
    queryFn: fetchValuePropPreferences,
    enabled: !!domain,
    ...options,
  });
};

export type ValuePropPreferencesQuery = ReturnType<typeof useValuePropPreferencesQuery>;
